/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FastEndpointsProblemDetails,
  FxIdWebFeaturesPlayManifestResponse,
} from '../models/index';
import {
    FastEndpointsProblemDetailsFromJSON,
    FastEndpointsProblemDetailsToJSON,
    FxIdWebFeaturesPlayManifestResponseFromJSON,
    FxIdWebFeaturesPlayManifestResponseToJSON,
} from '../models/index';

export interface FxIdWebFeaturesPlayManifestEndpointRequest {
    game: string;
}

/**
 * 
 */
export class ManifestApi extends runtime.BaseAPI {

    /**
     */
    async fxIdWebFeaturesPlayManifestEndpointRaw(requestParameters: FxIdWebFeaturesPlayManifestEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxIdWebFeaturesPlayManifestResponse>> {
        if (requestParameters['game'] == null) {
            throw new runtime.RequiredError(
                'game',
                'Required parameter "game" was null or undefined when calling fxIdWebFeaturesPlayManifestEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/manifest/{Game}`.replace(`{${"Game"}}`, encodeURIComponent(String(requestParameters['game']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesPlayManifestResponseFromJSON(jsonValue));
    }

    /**
     */
    async fxIdWebFeaturesPlayManifestEndpoint(game: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxIdWebFeaturesPlayManifestResponse> {
        const response = await this.fxIdWebFeaturesPlayManifestEndpointRaw({ game: game }, initOverrides);
        return await response.value();
    }

}
